export const asArray = (data) => (Array.isArray(data) ? data : [])
export const asText = (value) => (value == null ? '' : String(value))
export const toSelectOptions = (data) => {
    const seen = {}
    return asArray(data).map((item) => {
        if (item && typeof item === 'object') {
            const value = asText(item.value != null ? item.value : item.name)
            return { value, label: asText(item.name != null ? item.name : item.value) || value }
        }
        const value = asText(item)
        return { value, label: value }
    })
    .filter((option) => {
        if (option.value === '' || seen[option.value]) {
            return false
        }
        seen[option.value] = true
        return true
    })
}
